module.exports = {"410326100":"城关镇","410326101":"上店镇","410326102":"付店镇","410326103":"小店镇","410326104":"三屯镇","410326105":"刘店镇","410326106":"内埠镇","410326107":"陶营镇","410326200":"柏树乡","410326202":"十八盘乡","410326203":"靳村乡","410326204":"王坪乡","410326209":"蔡店乡","410326400":"大安工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410326.json
// module id = 1669
// module chunks = 0